import { IS_LOGGED_IN } from './queries';

const updateLoggedInStatus = (_, { isLoggedIn }, { cache }) => {
  if (!isLoggedIn) {
    localStorage.removeItem('authToken');
  }
  cache.writeQuery({
    query: IS_LOGGED_IN,
    data: {
      isLoggedIn: {
        __typename: 'isLoggedIn',
        login: isLoggedIn,
      },
    },
  });
  return null;
};

const resolvers = {
  Mutation: {
    updateLoggedInStatus,
  },
};

export default { resolvers };
